/**
 * Created by wumian on 17/11/21.
 */
import Vue from 'vue';


// 注册一个全局自定义指令 `v-focus`
Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  },
  update:function(el){
    el.focus()
  }
});



// WEBPACK FOOTER //
// ./src/assets/js/directive.js